import type { ReactNode } from 'react'
import Tooltip from 'core/elements/tooltip'
import { BatchActionDropdown } from './GridToolbar'
import type { GridBatchActionGroupProps, GridBatchActionProps } from './hooks/useGridSelectableRows'

interface BatchActionsContentProps<T> {
  batchActions?: GridBatchActionProps<T>[]
  dropdownBatchActions?: GridBatchActionGroupProps<T>[]
  renderDropdownOutside?: boolean
  actionWrapperClassName?: string
  actionWrapperDisabledClassName?: string
  dropdownContainerClassName?: string
  tooltipClassName?: string
}

export function BatchActionsContent<T>({
  batchActions,
  dropdownBatchActions,
  renderDropdownOutside = false,
  actionWrapperClassName,
  actionWrapperDisabledClassName,
  dropdownContainerClassName,
  tooltipClassName,
}: BatchActionsContentProps<T>): ReactNode {
  return (
    <>
      {batchActions?.map(
        ({
          key,
          label,
          triggerAction,
          BatchActionButton,
          tooltip,
          align = { vertical: 'top', horizontal: 'middle' },
          ...props
        }) => (
          <div
            key={key}
            className={props.disabled ? actionWrapperDisabledClassName : actionWrapperClassName}
            onClick={(e) => {
              if (props.disabled) {
                e.stopPropagation()
                return
              }
              triggerAction()
            }}
          >
            <Tooltip className={tooltipClassName} message={tooltip || ''} align={align}>
              <BatchActionButton {...props}>{label}</BatchActionButton>
            </Tooltip>
          </div>
        ),
      )}
      {!!dropdownBatchActions?.length && (
        <div className={dropdownContainerClassName}>
          {dropdownBatchActions.map(({ icon, label, actions }) => (
            <BatchActionDropdown<T>
              key={label}
              icon={icon}
              label={label}
              actions={actions}
              renderOutsideGrid={renderDropdownOutside}
            />
          ))}
        </div>
      )}
    </>
  )
}
